import { AdapterError, AssessmentAdapter } from './types'
import { SupervisoryAssessmentAdapter } from './SupervisoryAssessmentAdapter'
// Import shell adapters
import { PatAssessmentAdapter } from './PatAssessmentAdapter'
import { FuaAssessmentAdapter } from './FuaAssessmentAdapter'
import { DischargeAssessmentAdapter } from './DischargeAssessmentAdapter'
import { ServicePlanAssessmentAdapter } from './ServicePlanAssessmentAdapter'
import { SocAssessmentAdapter } from './SocAssessmentAdapter'
import { RecertAssessmentAdapter } from '../RecertAssessment/RecertAssessmentAdapter'
import { RocAssessmentAdapter } from '../RocAssessment/RocAssessmentAdapter'

import { AssessmentType } from '../../Clinical/Assessments/constants'

export class AdapterRegistry {
  private static adapters = new Map<AssessmentType, AssessmentAdapter>()

  // Auto-register all adapters when class is loaded
  static {
    this.register(new SupervisoryAssessmentAdapter()) // Fully implemented
    this.register(new SocAssessmentAdapter()) // Shell
    this.register(new PatAssessmentAdapter()) // Shell
    this.register(new RecertAssessmentAdapter()) // Shell
    this.register(new FuaAssessmentAdapter()) // Shell
    this.register(new DischargeAssessmentAdapter()) // Shell
    this.register(new RocAssessmentAdapter()) // Shell
    this.register(new ServicePlanAssessmentAdapter()) // Shell
  }

  /**
   * Register an adapter for a specific assessment type
   */
  static register<T extends AssessmentAdapter>(adapter: T): void {
    if (this.adapters.has(adapter.assessmentType)) {
      throw new AdapterError(
        `Adapter for assessment type ${adapter.assessmentType} is already registered`
      )
    }
    this.adapters.set(adapter.assessmentType, adapter)
  }

  /**
   * Get the adapter for a specific assessment type
   */
  static getAdapter(assessmentType: AssessmentType): AssessmentAdapter {
    const adapter = this.adapters.get(assessmentType)
    if (!adapter) {
      throw new AdapterError(`No adapter registered for assessment type: ${assessmentType}`)
    }
    return adapter
  }

  /**
   * Check if an adapter is registered for an assessment type
   */
  static hasAdapter(assessmentType: AssessmentType): boolean {
    return this.adapters.has(assessmentType)
  }

  /**
   * Get all registered assessment types
   */
  static getRegisteredTypes(): AssessmentType[] {
    return Array.from(this.adapters.keys())
  }
}
